import React, { Component } from "react";
import { connect } from "react-redux";

import { SelectItem } from "app/NativeComponents/snippets";
import {
  bulkUpdateLeads,
  setModal,
  updateModal,
  toggleModal
} from "app/NativeActions";

import { Copy } from "app/NativeComponents/common";

const FORCE_MOBILE_DEV_MODE = false;

class DeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCustomDeleteModal: false,
      deleteInput: "",
      error: "",
      hoverDelete: false
    };
  }

  determineDescription = selected_leads => {
    const singleLead = selected_leads.length === 1;
    const containsSmartListLead = selected_leads.some(lead =>
      lead?.deal?.lists?.some(list => list?.list_type === "build_list")
    );

    if (singleLead && containsSmartListLead) {
      const listName =
        selected_leads[0].deal.list_titles.length > 0 ? (
          <>
            <Copy inline style={{ fontWeight: "bold" }}>
              {
                selected_leads[0].deal.lists.find(
                  list => list.list_type === "build_list"
                ).title
              }
            </Copy>{" "}
            <Copy inline>list.</Copy>
          </>
        ) : (
          <Copy inline>a smart list.</Copy>
        );

      return (
        <Copy>
          This lead is a part of {listName}. When deleted, it will be added back
          on the next Smart List update. To avoid this, please move it to Trash.
        </Copy>
      );
    }

    if (containsSmartListLead) {
      return "Some selected leads are in a Smart List and will return. Move them to Trash instead.";
    }

    return "Are you sure you want to permanently delete these leads? This cannot be undone.";
  };

  renderCustomDeleteModal() {
    const { showCustomDeleteModal, deleteInput, hoverDelete, error } =
      this.state;
    const { colors, isMobile } = this.props;

    if (!showCustomDeleteModal || isMobile || FORCE_MOBILE_DEV_MODE) return null;

    const deleteIsValid = deleteInput.trim().toLowerCase() === "delete";

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: colors.modal_overlay || "rgba(0,0,0,0.7)",
          zIndex: 999999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div
          style={{
            backgroundColor: colors.background_color,
            border: `1px solid ${colors.border_color}`,
            borderRadius: 8,
            width: "90%",
            maxWidth: 420,
            padding: 20,
            boxSizing: "border-box",
            color: colors.text_color
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 700 }}>
            Type delete to continue
          </div>

          <div style={{ fontSize: 14, lineHeight: "20px", marginBottom: 10 }}>
            This will permanently delete these leads and all related activity.{" "}
            <strong>This cannot be undone.</strong>
            <br />
            <br />
            To hide leads without losing their history, set their status to{" "}
            <strong>In Trash</strong>.
            <br />
            <br />
            Learn more:&nbsp;
            <a
              href="https://help.dealmachine.com/en/articles/1891513-how-to-delete-leads"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: colors.link_color }}
            >
              How to Delete Leads
            </a>
          </div>

          <div style={{ color: colors.red_color, fontSize: 14 }}>
            ⚠ This cannot be undone.
          </div>

          <input
            type="text"
            autoFocus
            value={deleteInput}
            placeholder="delete"
            onChange={e =>
              this.setState({ deleteInput: e.target.value, error: "" })
            }
            style={{
              width: "100%",
              padding: "12px 10px",
              fontSize: 16,
              borderRadius: 8,
              border: `1px solid ${colors.border_color}`,
              marginBottom: 10,
              color: "black",
              boxSizing: "border-box"
            }}
          />

          {error ? (
            <div
              style={{
                color: colors.red_color,
                fontSize: 14,
                marginBottom: 10
              }}
            >
              {error}
            </div>
          ) : null}

          <button
            disabled={!deleteIsValid}
            onClick={() => this.handleFinalDelete()}
            onMouseEnter={() => this.setState({ hoverDelete: true })}
            onMouseLeave={() => this.setState({ hoverDelete: false })}
            style={{
              width: "100%",
              padding: "14px 0",
              fontSize: 16,
              borderRadius: 30,
              marginBottom: 10,
              border: `1px solid ${deleteIsValid ? colors.orange_color : colors.border_color
                }`,
              backgroundColor:
                deleteIsValid && hoverDelete
                  ? colors.orange_color
                  : "transparent",
              color:
                deleteIsValid && hoverDelete
                  ? "white"
                  : deleteIsValid
                    ? colors.orange_color
                    : colors.text_color_alt,
              cursor: deleteIsValid ? "pointer" : "not-allowed",
              transition: "all 0.2s ease"
            }}
          >
            Permanently Delete
          </button>

          <button
            onClick={() =>
              this.setState({
                showCustomDeleteModal: false,
                deleteInput: "",
                error: ""
              })
            }
            style={{
              width: "100%",
              padding: "10px 0",
              fontSize: 15,
              color: colors.active_color,
              background: "transparent",
              border: "none",
              cursor: "pointer"
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }

  handleFinalDelete(skipTypingCheck = false) {
    const { deleteInput } = this.state;
    const { isMobile } = this.props;

    if (!isMobile && !FORCE_MOBILE_DEV_MODE && !skipTypingCheck) {
      if (deleteInput.trim().toLowerCase() !== "delete") {
        this.setState({ error: "You must type delete exactly." });
        return;
      }
    }

    this.performDelete();

    this.setState({
      showCustomDeleteModal: false,
      deleteInput: "",
      error: ""
    });
  }

  performDelete() {
    const {
      token,
      selected_all,
      selected_leads,
      filtered_count
    } = this.props;

    this.props.bulkUpdateLeads({
      token,
      type: "permanently_delete",
      select_all: selected_all ? 1 : 0,
      total_count: selected_all ? filtered_count : selected_leads.length,
      filters: this.props.applied_filter?.filters || null,
      property_flags: this.props.lead_filters?.property_flags
        ?.map(f => f.value)
        .join(","),
      property_flags_and_or: this.props.lead_filters?.property_flags_and_or,
      search: this.props.search,
      search_type: this.props.search_type,
      list_id:
        this.props.active_list_tab?.id || this.props.active_list_tab,
      list_history_id: this.props.list_history_id || "",
      lead_ids: selected_all
        ? ""
        : selected_leads.map(p => p.deal.id).join(),
      onSuccess: () => {
        this.props.clearAll && this.props.clearAll();
      }
    });
  }

  render() {
    const { button_search, title, selected_leads, user, isMobile } = this.props;
    const deleteDescription = this.determineDescription(selected_leads);

    const mobileMode = isMobile || FORCE_MOBILE_DEV_MODE;

    return (
      <>
        {this.renderCustomDeleteModal()}

        {(!button_search ||
          title.toLowerCase().includes(button_search.toLowerCase())) &&
          user.can_delete_leads ? (
          <SelectItem
            select_type="none"
            icon="keyboard-arrow-right"
            onPress={() => {
              this.props.setModal({
                type: "normal",
                title: "Permanently Delete Leads",
                description: deleteDescription,
                icon: "delete",
                submit: "Continue",
                buttonType: "destroy",

                onPress: () => {
                  if (mobileMode) {
                    this.props.toggleModal({ show: false, type: "normal" });

                    setTimeout(() => {
                      this.props.setModal({
                        type: "normal",
                        title: "Confirm Delete",
                        description: (
                          <Copy>
                            This action will permanently delete the selected
                            leads.{" "}
                            <Copy inline style={{ fontWeight: "bold" }}>
                              This cannot be undone.
                            </Copy>
                          </Copy>
                        ),
                        submit: "Permanently Delete",
                        buttonType: "destroy",
                        onPress: () => {
                          this.handleFinalDelete(true);
                          return false;
                        },
                        cancel: "Cancel",
                        onCancel: () => { }
                      });

                      this.props.toggleModal({
                        show: true,
                        type: "normal"
                      });
                    }, 10);

                    return false;
                  }

                  this.setState({ showCustomDeleteModal: true });
                },

                cancel: "Cancel",
                onCancel: () => { }
              });

              this.props.toggleModal({ show: true, type: "normal" });
            }}
          >
            {title}
          </SelectItem>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = ({ auth, settings, modal, native }) => ({
  token: auth.token,
  user: auth.user,
  colors: settings.colors,
  modal,
  isMobile: native && native.isMobile
});

export default connect(mapStateToProps, {
  bulkUpdateLeads,
  setModal,
  updateModal,
  toggleModal
})(DeleteButton);
